import { Property, utils } from '@adc/ui-adc'
import { graph } from '@adc/constants'

/**
 * This is ugly. It is supposed to be, for two reasons:
 *
 * 1) These functions represent a break in v1/v2. It's not so much that we can't map back, it's that the new platform
 *    has new features that don't revert back easily -- like trying to place a cube block in a triangular slot.
 *
 * 2) Since not all apps are going out at the same time, this scopes the model changes only to the PDP to be shared
 *    across all components that use these model features, but without the risk of centrally publishing and breaking
 *    currently stable apps. There is a risk here that more logic is added to the central model that we are no
 *    overriding. Given the size of our team and recent conditions, it's not a risk that I am worried about when doing
 *    this.
 *
 * Practically, it also has a nice benefit of saying 'this is everything that fundamentally changed with the model when
 * repiping this app' before integrating back across other apps. The search app doesn't have this issue since it has
 * full ownership of it's own models and doesn't share. The topic of why different app have different models of what is
 * fundamentally the same data is a story in it's own right, and, briefly, is due to schema differences between a direct
 * read of a v1 property, and reading that same property from an index (was solr, now elasticsearch). Those differences
 * disappear with Morpheus via the Graph and so hopefully we should see fewer issues like this moving forward.
 *
 */

const existingAddressAsTuple = Object.getOwnPropertyDescriptor(
  Property.prototype,
  'addressAsTuple'
)

Object.defineProperty(Property.prototype, 'addressAsTuple', {
  get: function () {
    if (!this._property.listing) return existingAddressAsTuple.get.call(this)
    const { formatted_address: addressAsTuple } = this._property.listing

    return addressAsTuple
  },
})

const existingSpecialDocuments = Object.getOwnPropertyDescriptor(
  Property.prototype,
  'specialDocuments'
)
Object.defineProperty(Property.prototype, 'specialDocuments', {
  get: function () {
    if (!this._property.listing) return existingSpecialDocuments.get.call(this)

    const documentMapping =
      utils.dataTransformation.enumArrays.splitEnumArrayByField({
        original: this.documents,
        key: 'doc_type',
      })

    // prettier-ignore
    return {
      /**
       * Documents that are propagated from property documents to the listing level
       */
      titleReport: documentMapping[
        graph.enums.PropertyDocumentPurposeType.PRELIMINARY_TITLE_REPORT
      ],
      addendum:
        documentMapping[graph.enums.PropertyDocumentPurposeType.PROPERTY_CONDITION_ADDENDUM_AND_RELEASE]
        || documentMapping[graph.enums.GlobalMediaPurpose.PURCHASE_AGREEMENT_ADDENDUM],
      noticeOfSale: documentMapping[
        graph.enums.PropertyDocumentPurposeType.NOTICE_OF_SALE
      ],
      propertyInspectionReport: documentMapping[
        graph.enums.PropertyDocumentPurposeType.INSPECTION_REPORT
      ],
      additionalPropertyInfo: documentMapping[
        graph.enums.PropertyDocumentPurposeType.REDACTED_BROKER_PRICE_OPINION
      ],

      /**
       * Documents that come from marketing packages
       */
      sampleCertOfSale: documentMapping[
        graph.enums.GlobalMediaPurpose.SAMPLE_TRUSTEE_CERT_OF_SALE
      ],
      sampleDeed: documentMapping[
        graph.enums.GlobalMediaPurpose.SAMPLE_DEED
      ],
      purchaseAgreement: documentMapping[
        graph.enums.GlobalMediaPurpose.PURCHASE_AGREEMENT
      ],

      /**
       * Only required for TPS online -- mix of both.
       */
      termsAndConditions: this.isTPSOhio ? documentMapping[
        graph.enums.GlobalMediaPurpose.TERMS_AND_CONDITIONS
      ] : null,

      legalDescription: this.isTPSOhio ? documentMapping[
        graph.enums.PropertyDocumentPurposeType.LEGAL_DESCRIPTION
      ] : null,
    }
  },
})
